import type {CommentFieldsFragment} from '../../generated/types';

export type CommentNode = CommentFieldsFragment & {children: CommentNode[]};

/** глубже этого уровня ответы не сдвигаются вправо, а идут подряд, иначе на телефоне не остаётся места для текста */
export const MAX_INDENT_DEPTH = 4;

/**
 * Собирает дерево из плоского списка. Удалённые комментарии остаются только там,
 * где под ними есть живые ответы: ветка без них никому не нужна.
 */
export function buildCommentTree(comments: readonly CommentFieldsFragment[]): CommentNode[] {
	const nodes = new Map<string, CommentNode>();
	for (const comment of comments) nodes.set(comment.id, {...comment, children: []});

	const roots: CommentNode[] = [];
	for (const node of nodes.values()) {
		const parent = node.parentId ? nodes.get(node.parentId) : undefined;
		(parent ? parent.children : roots).push(node);
	}

	const prune = (list: CommentNode[]): CommentNode[] =>
		list
			.map((node) => ({...node, children: prune(node.children)}))
			.filter((node) => !node.isDeleted || node.children.length > 0);

	return prune(roots);
}

/** ветка вместе со всеми потомками одним списком, по порядку обхода */
export function flattenTree(nodes: CommentNode[]): CommentNode[] {
	return nodes.flatMap((node) => [node, ...flattenTree(node.children)]);
}
